import { HeaderCellProps } from '../../types';
import { Tooltip } from '@mui/material';

const ExceededRetriesHeaderCell = ({ _customRowProps }: HeaderCellProps) => {
  return (
    <Tooltip title="Number of entities that have exceeded a threshold of 25 retries">
      <div>Exceeded Retries</div>
    </Tooltip>
  );
};

export default ExceededRetriesHeaderCell;
